module.exports = __webpack_public_path__ + "e29f565b868c266bcabbcab653c82d69.svg";